export default function formatRUT(rut: string): string {
    const cleanedRUT = rut.replace(/[^0-9kK]/g, '');
    const body = cleanedRUT.slice(0, -1);
    const dv = cleanedRUT.slice(-1).toUpperCase(); 
    const formattedBody = body.replace(/\B(?=(\d{3})+(?!\d))/g, '.');
    return `${formattedBody}-${dv}`;
}